import React, { useEffect, useState, lazy } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { hot } from 'react-hot-loader/root';
import { Provider, useSelector } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import { BrowserRouter as Router, Redirect, Route } from 'react-router-dom';
import { ReactReduxFirebaseProvider, isLoaded } from 'react-redux-firebase';
import { ConfigProvider, Spin } from 'antd';
import store, { rrfProps } from './redux/store';
import Admin from './routes/admin';
import Auth from './routes/auth';
import Users from './routes/users/index';
import './static/css/style.css';
import config from './config/config';
import ProtectedRoute from './components/utilities/protectedRoute';
//const Home = lazy(() => import('../src/container/profile/authentication/overview/Home'));
import 'antd/dist/antd.less';
import firebase from 'firebase/app';
import 'firebase/auth';

const { theme } = config;

const ProviderConfig = () => {
  const { rtl, isLoggedIn, topMenu, darkMode, auth } = useSelector(state => {
    return {
      darkMode: state.ChangeLayoutMode.data,
      rtl: state.ChangeLayoutMode.rtlData,
      topMenu: state.ChangeLayoutMode.topMenu,
      isLoggedIn: state.auth.login,
      auth: state.fb.auth,
    };
  });

  const [path, setPath] = useState(window.location.pathname);

  useEffect(() => {
    let unmounted = false;
    if (!unmounted) {
      setPath(window.location.pathname);
    }
    // eslint-disable-next-line no-return-assign
    const unsubscribe = firebase.auth().onAuthStateChanged(async (user) => {
      if (user) {
        // User is signed in, check custom claims
        const tokenResult = await user.getIdTokenResult();
        // Check if 'admin' claim is present
        console.log("tokenResult.claims.role : ",tokenResult.claims.role);
        //const isAdminUser = !!tokenResult.claims.role && tokenResult.claims.role === 'admin';
        //console.log("isAdminUser : ",isAdminUser);

        //setIsAdmin(isAdminUser);
      } else {
        // User is signed out
        //setIsAdmin(false);
      }
    });


    return () => (unmounted = true);

    
  }, [setPath]);

  return (
    <ConfigProvider direction={rtl ? 'rtl' : 'ltr'}>
      <ThemeProvider theme={{ ...theme, rtl, topMenu, darkMode }}>
        <ReactReduxFirebaseProvider {...rrfProps}>
          {!isLoaded(auth) ? (
            <div className="spin">
              <Spin />
            </div>
          ) : (
            <Router basename={process.env.PUBLIC_URL}>
              {!isLoggedIn ?
                <Route path="/" component={Auth} /> :
                <>
                  <ProtectedRoute path="/admin" component={Admin} />
                </>
              }

              {/* {isLoggedIn && (path === process.env.PUBLIC_URL || path === `${process.env.PUBLIC_URL}/`) && (
                <Redirect to="/admin" />
              )} */}

              {isLoggedIn &&
                <>
                  <Route exact path="/host-athletes" component={Users} />
                  <Route exact path={`/about-us`} component={Users} />
                  <Route path={`/home`} component={Users} />
                  <Route path="/find-housing-for-athletes" component={Users} />
                  <Route exact path="/PlaceDetails/:url" component={Users} />
                  <Route exact path="/PlaceList" component={Users} />
                  <Route exact path="/map-listings" component={Users} />
                </>
              }
            </Router>
          )}
        </ReactReduxFirebaseProvider>
      </ThemeProvider>
    </ConfigProvider>
  );
}

function App() {
  return (
    <Provider store={store}>
      <ProviderConfig />
    </Provider>
  );
}

export default hot(App);
